/**
 * What the Renewal Rules panel shows under its list: the load error or the
 * empty-state line, and the offer of the pricing team's standard rules to a
 * supplier with none.
 */
export interface RenewalRulesPanelState {
  /** The error or empty-state line shows. */
  showMessage: boolean;
  /** "Add Standard Rules" shows. */
  offerStandardRules: boolean;
}

export function renewalRulesPanelState({
  ruleCount,
  unreadableCount,
  isLoading,
  isError,
  canCreate,
}: {
  ruleCount: number;
  unreadableCount: number;
  isLoading: boolean;
  isError: boolean;
  canCreate: boolean;
}): RenewalRulesPanelState {
  const isEmpty = ruleCount === 0 && unreadableCount === 0 && !isLoading;
  return {
    showMessage: isError || isEmpty,
    offerStandardRules: isEmpty && !isError && canCreate,
  };
}

/**
 * Saves `drafts` one after another; false when one fails (its mutation has
 * already shown the toast), so the caller stops there.
 */
export async function saveAll<Draft>(
  drafts: readonly Draft[],
  save: (draft: Draft) => Promise<unknown>,
): Promise<boolean> {
  try {
    for (const draft of drafts) await save(draft);
  } catch {
    return false;
  }
  return true;
}
